import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import QuickEventForm from '../../../components/forms/QuickEventForm';
import { useQuickEventApi } from '../../../hooks/useQuickEventApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { QuickEventDTO } from '../../../services/apiClient';

const QuickEventEdit: React.FC = () => {
  const { getById, edit, isLoading } = useQuickEventApi();
  const [entityData, setEntityData] = useState<QuickEventDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Quick Events', href: '/admin/quickevents' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching QuickEvent data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/quickevents');
    } catch (error) {
      console.error('Error updating QuickEvent:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/quickevents"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.QuickEvent.Edit'
    >
        {entityData ? (
          <QuickEventForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/quickevents')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default QuickEventEdit;